import { mapKeys, mapValues, isPlainObject } from 'lodash';
export default function recursiveMapKeys(input, fn) {
    if (Array.isArray(input)) {
        return input.map(x => recursiveMapKeys(x, fn));
    }
    else if (input instanceof Object && isPlainObject(input)) {
        return mapKeys(mapValues(input, v => recursiveMapKeys(v, fn)), (_, key) => fn(key));
    }
    else {
        return input;
    }
}
//# sourceMappingURL=recursiveMapKeys.js.map